import { useMemo } from 'react';

const KNOWN_DOMAINS = [
  'gmail.com', 'googlemail.com',
  'yahoo.com', 'yahoo.de', 'yahoo.fr', 'yahoo.it',
  'hotmail.com', 'hotmail.de', 'hotmail.fr', 'hotmail.ch',
  'outlook.com', 'outlook.de', 'outlook.fr',
  'live.com', 'live.de',
  'icloud.com', 'me.com', 'mac.com',
  'aol.com',
  'gmx.de', 'gmx.ch', 'gmx.at', 'gmx.net',
  'web.de',
  'bluewin.ch',
  'protonmail.com', 'proton.me',
  'mail.com', 'email.com',
  'msn.com',
  'yandex.com', 'yandex.ru',
  'zoho.com',
  'pm.me',
  'sunrise.ch',
  'hispeed.ch',
];

function levenshtein(a: string, b: string): number {
  const m = a.length, n = b.length;
  const dp: number[][] = Array.from({ length: m + 1 }, () => Array(n + 1).fill(0));
  for (let i = 0; i <= m; i++) dp[i][0] = i;
  for (let j = 0; j <= n; j++) dp[0][j] = j;
  for (let i = 1; i <= m; i++) {
    for (let j = 1; j <= n; j++) {
      dp[i][j] = a[i - 1] === b[j - 1]
        ? dp[i - 1][j - 1]
        : 1 + Math.min(dp[i - 1][j], dp[i][j - 1], dp[i - 1][j - 1]);
    }
  }
  return dp[m][n];
}

export function useEmailTypoCheck(email: string): string | null {
  return useMemo(() => {
    if (!email || !email.includes('@')) return null;
    const [local, domain] = email.split('@');
    if (!domain || !local) return null;
    const domainLower = domain.toLowerCase();

    // Already a known domain
    if (KNOWN_DOMAINS.includes(domainLower)) return null;

    // Find closest match with distance <= 2
    let bestMatch: string | null = null;
    let bestDist = 3; // threshold
    for (const known of KNOWN_DOMAINS) {
      const dist = levenshtein(domainLower, known);
      if (dist > 0 && dist < bestDist) {
        bestDist = dist;
        bestMatch = known;
      }
    }

    return bestMatch ? `${local}@${bestMatch}` : null;
  }, [email]);
}
